// @flow
import * as React from 'react';
import styled, { keyframes, css } from 'styled-components';
import ClipboardButton from 'react-clipboard.js';
import { buttonStyles } from 'components/Button';
import Icon from 'components/Icon';
import Box from 'components/Box';
import Tile, { TileBody } from 'components/Tile';
import { H3, Body } from 'components/Text';
import ClientOnly from 'containers/ClientOnly';
import { colors } from 'theme';

const { useState } = React;

const CopyButton = styled(ClipboardButton)`
  ${buttonStyles};
  width: 100%;
  background: ${colors.waterBlue};
  color: white;
  &:hover {
    background: ${colors.turtleGreen};
  }
`;

const aTranslate = keyframes`
  0%, 100% {
    transform: translateY(0);
    color: rgba(255, 255, 255, 1);
  }
  10%, 90% {
    transform: translateY(-100%);
    color: rgba(255, 255, 255, 0);
  }
`;

const aFade = keyframes`
  0%, 100% {
    opacity: 0;
  }
  10%, 90% {
    opacity: 1;
  }
`;

const Message = styled(Box)`
  &::after {
    content: '${getText('Copied!')}';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    opacity: 0;
    color: white;
  }
  ${props =>
    props.$copied
      ? css`
          animation: ${aTranslate} 3s forwards;
          &::after {
            animation: ${aFade} 3s forwards;
          }
        `
      : ''}
`;

export default () => {
  const [copied, setCopied] = useState(false);

  const showMessage = () => {
    setCopied(true);
    window.setTimeout(() => {
      setCopied(false);
    }, 3000);
  };

  return (
    <Tile boxShadow="0 3px 7px 1px rgba(0,0,0,0.15)">
      <TileBody>
        <H3>
          {getText(
            'Payment information is not supported in Internet Explorer.'
          )}
        </H3>
        <Body>
          {getText(`Please use another browser such as Chrome, Firefox, Safari, 
        or Microsoft Edge to continue the payment process.`)}
        </Body>
        <ClientOnly>
          <Box position="relative" mt={48}>
            <CopyButton
              data-clipboard-text={
                typeof window === 'undefined' ? '' : window.location.href
              }
              size="large"
              onClick={showMessage}
            >
              <Box display="flex" alignItems="center" justifyContent="center">
                <Icon
                  name="clipboard"
                  display="block"
                  width={20}
                  height={20}
                  mr="6px"
                  fill="currentColor"
                />
                <Message position="relative" $copied={copied}>
                  {getText('Copy Current URL')}
                </Message>
              </Box>
            </CopyButton>
          </Box>
        </ClientOnly>
      </TileBody>
    </Tile>
  );
};
